import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
declare var bootbox:any;
@Component({
  selector: 'app-organization-ne',
  template: require('./organization-ne.component.html')
})
export class OrganizationNeComponent extends BaseComponent implements OnInit {

  public organization = {
    name: "",
    address:"",
    contactPersonName: "",
    contactPersonPhone: "",
    logoFilename: ""
  };

  public organizationId = -1;

  
  ngOnInit() {
    super.ngOnInit();
  }

  public routeParamsUpdated() {
    this.organizationId = this.default(this.currentRouteParams["orgId"],-1);
    if(this.organizationId>0)
      this.loadOrganizationById();
    else 
      this.organizationId = -1;
  }

  public loadOrganizationById() {
      this.busy = this.lsApi.getOrganizationById(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.organization = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.organization.name)) {
        errorMessage = "Please provide a name for this organization";
    }
    else if(validate.isEmpty(this.organization.address)) {
        errorMessage = "Please provide a address for this organization";
    }
    else if(validate.isEmpty(this.organization.contactPersonName)) {
        errorMessage = "Please provide a contact person's name for this organization";
    }
    else if(validate.isEmpty(this.organization.contactPersonPhone)) {
        errorMessage = "Please provide a contact person's phone for this organization";
    }

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        this.busy = this.lsApi.SaveOrganization(this.organizationId, this.organization.name, this.organization.address, this.organization.contactPersonName, this.organization.contactPersonPhone, this.file).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/organizations']).then(() => {
                  this.appToast.success("Organization Successfully Saved","Organization Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/organizations']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.organization.name + "' organization and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteOrganization(this.organizationId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/organizations']).then(() => {
                    this.appToast.success("Organizations Successfully Deleted","Organizations Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public file:any = null;
  public fileChange(event) {
      var that = this;
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {

        var ext = fileList[0].name.match(/\.([^\.]+)$/)[1];
        switch(ext.toLowerCase())
        {
            case 'jpeg':
            case 'jpg':
            case 'png':
                break;
            default:
            bootbox.alert("Logo file must be of the format .jpg, .jpeg or .png");
            return false;
        }

        
        var reader = new FileReader();
        //Read the contents of Image File.
        reader.readAsDataURL(fileList[0]);
        reader.onload = function (e:any) {
            //Initiate the JavaScript Image object.
            var image = new Image();

            //Set the Base64 string return from FileReader as source.
            
            image.src = e.target.result;
                    
            //Validate the File Height and Width.
            image.onload = function () {
                var x = this as HTMLImageElement;
                var height = x.height;
                var width = x.width;
                console.log(height);
                if ((height>200 || width > 200) || (height<=0 || width<=0)) {
                    bootbox.alert("Logo image file must be of the max resolution 200px by 200px (width x height) @ 75dpi");
                    //alert("Height and Width must be exactly 2 not exceed 100px.");
                    return false;
                }
                that.file = fileList[0];
                (document.getElementById("imgLogo") as HTMLImageElement).src = e.target.result;
                return true;
            };
        };

            
        //let file: File = fileList[0];
        //this.file = file;   
    }
    else {
        this.file = null;
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-ne/organization-ne.component.ts